var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3675_144370)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92187 13.7256C4.26705 13.7256 4.54687 14.0054 4.54687 14.3506V16.0173C4.54687 16.2935 4.65662 16.5585 4.85197 16.7538C5.04732 16.9492 5.31227 17.0589 5.58854 17.0589H15.5885C15.8648 17.0589 16.1298 16.9492 16.3251 16.7538C16.5205 16.5585 16.6302 16.2935 16.6302 16.0173V14.3506C16.6302 14.0054 16.91 13.7256 17.2552 13.7256C17.6004 13.7256 17.8802 14.0054 17.8802 14.3506V16.0173C17.8802 16.625 17.6388 17.2079 17.209 17.6377C16.7792 18.0675 16.1963 18.3089 15.5885 18.3089H5.58854C4.98075 18.3089 4.39786 18.0675 3.96809 17.6377C3.53832 17.2079 3.29688 16.625 3.29688 16.0173V14.3506C3.29688 14.0054 3.5767 13.7256 3.92187 13.7256Z",
    fill: "#8C8FA4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97993 8.90864C6.22401 8.66457 6.61974 8.66457 6.86382 8.90864L10.5885 12.6334L14.3133 8.90864C14.5573 8.66457 14.9531 8.66457 15.1972 8.90864C15.4412 9.15272 15.4412 9.54845 15.1972 9.79253L11.0305 13.9592C10.7864 14.2033 10.3907 14.2033 10.1466 13.9592L5.97993 9.79253C5.73586 9.54845 5.73586 9.15272 5.97993 8.90864Z",
    fill: "#8C8FA4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5879 2.8916C10.9331 2.8916 11.2129 3.17142 11.2129 3.5166V13.5166C11.2129 13.8618 10.9331 14.1416 10.5879 14.1416C10.2427 14.1416 9.96289 13.8618 9.96289 13.5166V3.5166C9.96289 3.17142 10.2427 2.8916 10.5879 2.8916Z",
    fill: "#8C8FA4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3675_144370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.587891 0.183594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.116aa9c151be590bf336eb907b44f1b1.svg";
export { ForwardRef as ReactComponent };